import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {useIndividualTrainingChiliPiperDialog} from '../../../onboarding/chiliPiper/individualTrainingChiliPiperDialog';

/*
 * Component.
 */

export const BottomBarIndividualTrainingButton: FC = () => {
  const [individualTrainingDialog, onIndividualTrainingClick] = useIndividualTrainingChiliPiperDialog(
    OnboardingDataEventObject.INDIVIDUAL_TRAINING,
  );

  return (
    <>
      <Button size={VisualSizesEnum.SMALL} onClick={onIndividualTrainingClick} leftIcon="phoneSmall">
        <Trans id="bottom-bar-individual-training-button">Get 1:1 help</Trans>
      </Button>
      {individualTrainingDialog}
    </>
  );
};
